var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exp-msg',{attrs:{"title":"抱歉，服务器出错了！"}},[_c('div',{attrs:{"slot":"image"},slot:"image"},[_c('img',{attrs:{"src":require("./imgs/preview.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }